<script lang="ts" setup>
import { computed, ref, watch } from "vue";
import { ChevronDownCompact } from "tir-style-system/icons/solid";

const props = defineProps({
  /**Видно ли тело списка */
  visible: {
    type: Boolean,
    default: false,
  },
  /**Режим открытия по флагу из пропса */
  flagMode: {
    type: Boolean,
    default: false,
  },
  /**Задержка */
  delay: {
    type: Number,
    default: 500,
  },
  /**Отключить анимацию */
  disableAnimation: {
    type: Boolean,
    default: false
  }
});

/**События */
const emit = defineEmits<{
  /**Открытие элемента */
  open: [];
  /**Событие изменения флага */
  "update:visible": [visible: boolean];
}>();

/**Видно ли тело списка */
const innerVisible = ref(props.visible);
/**Элемент тела компонента */
const $body = ref<HTMLDivElement>();
/**Позиционирование и размеры блока */
const bodyRect = ref<DOMRect>();

/**Стили тела компонента */
const bodyStyle = computed(() => ({
  height: bodyRect.value ? `${bodyRect.value.height}px` : "",
}));

watch(
  () => props.visible,
  () => {
    if (props.flagMode && innerVisible.value !== props.visible) {
      toggleVisibility(true);
    }
  },
);

/**Переключение видимости тела компонента */
const toggleVisibility = (fromWatch: boolean = false) => {
  if (props.flagMode) {
    if (fromWatch) {
      innerVisible.value = !innerVisible.value;
    } else {
      emit("update:visible", !innerVisible.value);
    }

    return;
  }

  if (innerVisible.value) {
    bodyRect.value = $body.value?.getBoundingClientRect?.();
    setTimeout(() => {
      innerVisible.value = !innerVisible.value;
    });
  } else {
    bodyRect.value = undefined;
    setTimeout(() => {
      innerVisible.value = !innerVisible.value;
    }, props.delay);
    if (!fromWatch) emit("open");
  }
};
</script>
<template>
  <div class="label-content">
    <div class="label-content_header" @click="toggleVisibility(false)">
      <slot name="header" />
      <ChevronDownCompact class="label-content_header_arrow" :class="{ visible: innerVisible }" />
    </div>
    <Transition name="label-content_fade">
      <div v-show="innerVisible" ref="$body" :class="['label-content_body', {'disable-animation': disableAnimation}]" :style="bodyStyle">
        <slot />
      </div>
    </Transition>
  </div>
</template>
<style lang="scss" scoped>
.label-content {
  display: flex;
  flex-direction: column;
  position: relative;
  // padding: 0.5rem;
  &_header {
    position: relative;
    display: flex;
    align-items: center;
    gap: 0.25rem;
    width: 100%;
    min-height: 2rem;
    min-height: 2rem;
    padding: 0.25rem 0 0.25rem 2.25rem;
    background: var(--bg-base);
    border-radius: 0.25rem;
    cursor: pointer;
    transition: 0.2s linear;
    user-select: none;
    &:hover {
      background: var(--neutral-translucent-10);
    }
    &_arrow {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 2rem;
      height: 2rem;
      color: var(--text-primary);
      transition: 0.2s linear;
      &.visible {
        transform: translateY(-50%) rotate(180deg);
      }
    }
  }
  &_body {
    display: flex;
    flex-direction: column;
    margin-top: 1.5rem;
    margin-bottom: 1rem;
    
    &:not(.disable-animation) {
      transition: 0.4s ease-in-out;
    }
  }

  &_fade-leave-active {
    overflow: hidden;
  }
  &_fade-leave-to {
    opacity: 0;
    height: 0 !important;
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>
